import { NavLink, Outlet } from 'react-router-dom';
import { useT } from '../../i18n/I18nProvider';

/**
 * The Administration area (Phase 2.4).
 *
 * Replaces the single `/admin` mega-page with a settings layout: a grouped secondary
 * navigation over sub-routes, so low-frequency administrative surfaces live here
 * behind one primary sidebar entry rather than as many top-level links. Groups follow
 * the audit's settings taxonomy; only sections that have real pages are shown.
 */
const SETTINGS: Array<{
  groupKey: string;
  items: Array<{ to: string; labelKey: string; end?: boolean }>;
}> = [
  {
    groupKey: 'admin.groups.account',
    items: [{ to: '/admin', labelKey: 'admin.profileMfa', end: true }],
  },
  {
    groupKey: 'admin.groups.security',
    items: [{ to: '/admin/security', labelKey: 'admin.accessAudit' }],
  },
  {
    groupKey: 'admin.groups.operations',
    items: [{ to: '/admin/operations', labelKey: 'admin.maintenanceSupport' }],
  },
  {
    groupKey: 'admin.groups.developer',
    items: [{ to: '/admin/tokens', labelKey: 'admin.apiTokens' }],
  },
];

export function AdministrationLayout(): JSX.Element {
  const t = useT();
  return (
    <section>
      <div className="page-head">
        <h1>{t('pages.administration.title')}</h1>
      </div>
      <div className="settings">
        <nav className="settings-nav" aria-label={t('pages.administration.title')}>
          {SETTINGS.map((group) => (
            <div key={group.groupKey} className="settings-nav__group">
              <div className="settings-nav__header">{t(group.groupKey)}</div>
              {group.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `settings-nav__link${isActive ? ' active' : ''}`}
                >
                  {t(item.labelKey)}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="settings-content">
          <Outlet />
        </div>
      </div>
    </section>
  );
}
